'use client'
import { AppLink, AppLinkProps, AppPathContext } from 'app/_components/AppLink'
import { Button } from 'app/_components/Button'
import { usePathname } from 'next/navigation'
import { use } from 'react'
import { twMerge } from 'tailwind-merge'

type LinkItemProps = AppLinkProps & {
  href: `/${string}`
  active?: boolean
  highlightOrientation?: 'horizontal' | 'vertical'
}

export default function LinkItem({
  children,
  href,
  target = '_self',
  className,
  active,
  highlightOrientation = 'horizontal',
  ...props
}: LinkItemProps) {
  const appPath = use(AppPathContext)
  const pathname = usePathname()

  const isActive =
    active !== undefined
      ? active
      : href !== `${appPath}/` && pathname?.startsWith(appPath + href)

  return (
    <AppLink href={href} tabIndex={-1} target={target} {...props}>
      <Button
        className={twMerge(
          'text-text-secondary hover:bg-gray-10 flex w-full items-center gap-2 border-l-[3px] border-transparent bg-white py-2 text-left focus-visible:ring-inset md:border-b-[3px] md:border-l-0 md:px-4 md:pt-3 md:pb-[9px] [&>svg]:shrink-0',
          highlightOrientation === 'vertical' &&
            'md:border-b-0 md:border-l-[3px]',
          isActive &&
            'border-primary text-text-primary bg-gray-10 md:bg-inherit',
          className,
        )}
        variant="nav"
        role="link"
      >
        {children}
      </Button>
    </AppLink>
  )
}
